module.exports = __webpack_public_path__ + "static/img/1.8f9be8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/1.png
// module id = uosB
// module chunks = 35